class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.addToCartButton = this.querySelector('.add-to-cart');
        this.current_variant_id = this.getAttribute('variant-id');
        this.productHandle = this.getAttribute('product-handle');

        this.variants = JSON.parse(this.querySelector('#product-variants-json').innerText); // <- Make sure to include a script tag with id="product-variants-json" in your HTML that contains the variants data in JSON format.
        this.currentVariant = this.variants.find(variant => variant.id == this.getAttribute('variant-id'));
    }   
    updatePrice(variantId) {
        const priceEl = document.querySelector('.price .price-item--sale, .price .price-item--last'); 
        const comparePriceEls = document.querySelectorAll('.price .price-item--regular'); 
        const badgeEls = document.querySelectorAll('.main-product-badge');

        const priceCents = this.currentVariant.price_cents || 0;
        const compareCents = this.currentVariant.compare_at_price_cents || 0;

        // ✅ Format money dynamically
        const formatMoney = (cents) => {
            const activeCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}';
            const v = Number(cents) / 100;

            if (isNaN(v)) return '0.00';

            // Special case: Danish Krone formatting
            if (activeCurrency === "DKK") {
                return v.toLocaleString("da-DK", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + " kr";
            }

            // All other currencies
            try {
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: activeCurrency
                }).format(v);
            } catch (e) {
                // Fallback if Intl fails
                return v.toFixed(2) + ' ' + activeCurrency;
            }
        };

        // ✅ Update price
        if (priceEl) {
            priceEl.innerText = formatMoney(priceCents);
        }

        // ✅ Update compare-at price
        if (comparePriceEls.length > 0) {
            if (compareCents > priceCents) {
                comparePriceEls.forEach(el => { 
                    el.innerText = formatMoney(compareCents);
                    el.style.display = 'inline';
                });
            } else {
                comparePriceEls.forEach(el => { el.style.display = 'none'; });
            }
        }

        // ✅ Update discount badge
        if (badgeEls.length > 0) {
            badgeEls.forEach(badge => {
                if (compareCents > priceCents) {
                    const discount = Math.round(((compareCents - priceCents) / compareCents) * 100);
                    badge.innerText = `Spar ${discount}%`;
                    badge.style.display = 'inline';
                } else {
                    badge.style.display = 'none';
                }
            });
        }
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.addEventListener('change', this.updateVariant.bind(this));

        // If JavaScript is working, hide the variant select dropdown and show the radios instead
        if (this.querySelector('#main-variant-select')) this.querySelector('#main-variant-select').style.display = 'none'; 
        if (this.querySelector('.product-variant-options')) this.querySelector('.product-variant-options').style.display = 'block';
    }

    disconnectedCallback() {
        this.removeEventListener('submit', this.handleFormSubmit.bind(this));
        this.removeEventListener('change', this.updateVariant.bind(this));
    }
    updateVariant() {
        // Collect all selected option values (Color, Size, etc.)
        let selectedOptions = [];
        this.querySelectorAll('[name^="option-"]:checked').forEach(input => {
            selectedOptions.push(input.value);

            // update selected value text in UI
            let wrapper = input.closest('.variant-option');
            if (wrapper) {
                wrapper.querySelector('.selected-value').innerText = input.value;
            }
        });

        // Match variant from all options
        this.currentVariant = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions));
        // console.log('Current Variant:', this.currentVariant);

        if (!this.currentVariant) return;

        // Update hidden variant ID input
        this.querySelector('.selected-variant-id').value = this.currentVariant.id;

        // Update history state (URL)
        window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);


        // Update Swiper slider image according to variant image
        if (this.currentVariant.featured_image) {
            let imageId = this.currentVariant.featured_image.id;

            let index = Array.from(document.querySelectorAll('.main-slider img'))
                            .findIndex(img => img.dataset.imageId == imageId);

            if (index >= 0 && window.mainSlider) {
                window.mainSlider.slideTo(index);
            }
        }


        // ✅ Call the class method with `this`
        this.updatePrice(this.currentVariant.id);

        // Update add to cart button
        const inputButton = this.querySelector('button[type="submit"]');
        if (!this.currentVariant.available) {
            inputButton.setAttribute('disabled', '');
            inputButton.innerText = 'SOLD OUT';
        } else {
            inputButton.removeAttribute('disabled');
            inputButton.innerText = 'Add to cart';
        }
    }
    handleFormSubmit(evt) {
        evt.preventDefault();

        let formData = new FormData(this.form);
        document.querySelector('side-cart').classList.remove('loaded');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            return response.json();
        })
        .then(json_response => {
            console.log(json_response);
            if(json_response.status != 'bad_request') {
                // alert('One '+json_response.product_title+' added to the cart ✓');
                document.querySelector('side-cart').addLineItem(json_response);
            } else {
                alert('Error: '+json_response.message);
            }
        })
        .catch((error) => {
            alert('Error: '+error);
            console.error('Error:', error);
        });
    }
}

customElements.define('product-form', ProductForm);